import { Box } from '@material-ui/core';
import { GridCellProps } from '@progress/kendo-react-grid';
import React, { SyntheticEvent, useState } from 'react';
import { TextField } from '../../../components/forms/fields-next';
import { DTMRowItem } from '../types';

export const IntegerNumberCell: React.FunctionComponent<Omit<GridCellProps, 'dataItem'> & { dataItem: DTMRowItem }> = ({
  dataItem,
  field,
  onChange,
  dataIndex,
  rowType,
  colSpan,
  style,
  className = '',
  columnIndex,
}) => {
  const path = field ?? '';
  const editMode = Boolean(dataItem.inEdit);
  const dataValue = Number(dataItem[path] ?? 0);
  const [value, setValue] = useState<number>(dataValue);

  const handleBlur = (syntheticEvent: SyntheticEvent) => {
    onChange?.({
      dataIndex,
      dataItem,
      syntheticEvent,
      field,
      value,
    });
  };

  if (rowType === 'groupHeader') {
    return null;
  }

  return (
    <td
      colSpan={colSpan}
      style={style}
      role="gridcell"
      className={`checkbox-cell ${className}`}
      data-grid-col-index={columnIndex}
    >
      {editMode ? (
        <TextField
          id="k-input-dtm-sn"
          value={value}
          onChange={(e) => setValue(Number(e.target.value))}
          onBlur={handleBlur}
          type="number"
          size="small"
          inputProps={{
            min: 0,
          }}
        />
      ) : (
        <Box display="flex">{dataValue}</Box>
      )}
    </td>
  );
};
